import { IdentityProvider, BusinessIdentityProvider } from '@izettle/constants';
import { captureMessage } from '@sentry/react';

const getServiceUrl = subdomain => `https://${subdomain}.${process.env.APP_ENV === "production" ? "izettle" : "izettletest"}.com`;

/**
 * Used for checking if we need to load a web component from the web.
 * If we're running in Jest we don't need to.
 */
const shouldLoadWebComponent = name => process.env.JEST_WORKER_ID == null && document.createElement(name).constructor === HTMLElement;
const getShowPayPalWidget = (isImpersonatedUser, identityProvider, businessIdentityProvider) => !isImpersonatedUser && (identityProvider === IdentityProvider.IzTenant || businessIdentityProvider === BusinessIdentityProvider.PayPal);
const snakeCaseRegex = /([\da-zA-Z]+)(?:_([\w\d]))?/g;
const snakeCaseToCamelCase = str => str.replace(snakeCaseRegex, (_match, word, nextLetter) => word + (nextLetter ? nextLetter.toUpperCase() : ""));
const convertKeysFromSnakeToCamelCase = obj => Object.entries(obj).reduce((accum, _ref) => {
  let [key, value] = _ref;
  if (typeof value === "object" && !Array.isArray(value)) {
    value = convertKeysFromSnakeToCamelCase(value);
  }
  return {
    ...accum,
    [snakeCaseToCamelCase(key)]: value
  };
}, {});
const transformSettings = data => Object.fromEntries(data.map(_ref2 => {
  let {
    key,
    value
  } = _ref2;
  let parsedValue = {};
  try {
    parsedValue = JSON.parse(value);
  } catch {
    if (key !== "PRODUCT_LIBRARY_NAME") {
      captureMessage(`Found unexpected non-JSON setting: ${key}`);
    }
  }
  return [key, parsedValue];
}));

/* istanbul ignore next */
const pushGTMVisitorInfoDataLayer = userData => {
  window.dataLayer ??= [];
  window.dataLayer.push({
    event: "Demographics",
    visitorId: userData.organization.fullOrganizationUuid,
    visitorLoginState: "loggedIn",
    visitorType: userData.organization.legalEntityType,
    visitorDemographicInfo: [userData.locale.language, userData.locale.country, userData.user.timeZoneId]
  });
};

/* istanbul ignore next */
const setHtmlLang = userData => {
  const htmlElement = document.querySelector("html");
  htmlElement?.setAttribute("lang", userData.locale.language);
};

/* istanbul ignore next */
const removeLoader = function () {
  let waitMs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 50;
  // Allow delaying removing loader
  setTimeout(() => {
    // Handle if the loader has been removed by another process
    const loader = document.getElementById("loader");
    if (loader == null) {
      return;
    }
    loader.classList.add("fade-out");

    // Remove the element when it has fully faded out
    setTimeout(() => {
      loader.remove();
    }, 1000);
  }, waitMs);
};

export { convertKeysFromSnakeToCamelCase, getServiceUrl, getShowPayPalWidget, pushGTMVisitorInfoDataLayer, removeLoader, setHtmlLang, shouldLoadWebComponent, snakeCaseToCamelCase, transformSettings };
//# sourceMappingURL=rest.js.map
